module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-11-bfccaf9a0e13a583b29d2407f7259243.png";